import { makeElementAnchor } from "views/components/visualizations/OnClickPopover/anchors";
import dropdownPopover from "views/components/visualizations/OnClickPopover/dropdownPopover";
import CartesianOnClickPopoverDropdown from "views/components/visualizations/OnClickPopover/CartesianOnClickPopoverDropdown";
const getBarElement = (graphDiv, pt, curveNumberRenderIndexMapper) => {
  var _a, _b;
  const { curveNumber, pointIndex } = pt;
  const traceIndex = curveNumberRenderIndexMapper[curveNumber];
  const trace = graphDiv.querySelectorAll(".cartesianlayer .trace")[traceIndex];
  if (!trace) return null;
  const point = trace.querySelectorAll(".point")[pointIndex];
  return (_b = (_a = point == null ? void 0 : point.querySelector("rect")) != null ? _a : point == null ? void 0 : point.querySelector("path")) != null ? _b : null;
};
const listSubplotOrder = (gd) => {
  const subplots = gd.querySelectorAll(".cartesianlayer g.subplot");
  return Array.from(subplots).map((node) => {
    const idClass = Array.from(node.classList).find((cls) => cls !== "subplot");
    return idClass != null ? idClass : "";
  });
};
const createBarElementGetter = (gd) => {
  const fullData = gd._fullData;
  const curveNumberGroupedBySubPlot = {};
  fullData.forEach(({ xaxis, yaxis }, curveNumber) => {
    const subplot = `${xaxis != null ? xaxis : "x"}${yaxis != null ? yaxis : "y"}`;
    (curveNumberGroupedBySubPlot[subplot] || (curveNumberGroupedBySubPlot[subplot] = [])).push(curveNumber);
  });
  const subPlotDOMOrder = listSubplotOrder(gd);
  const curveNumberRenderIndexArray = subPlotDOMOrder.flatMap((subPlotId) => curveNumberGroupedBySubPlot[subPlotId]);
  const curveNumberRenderIndexMapper = Object.fromEntries(curveNumberRenderIndexArray.map((v, i) => [v, i]));
  return (graphDiv, pt) => getBarElement(graphDiv, pt, curveNumberRenderIndexMapper);
};
const buildAnchor = (e, gd) => makeElementAnchor(e, gd, createBarElementGetter(gd));
const barOnClickPopover = {
  buildAnchor,
  renderPopover: dropdownPopover(CartesianOnClickPopoverDropdown)
};
export default barOnClickPopover;
